import React, { useState, useEffect } from 'react';
import { Link ,useNavigate} from 'react-router-dom';

import MainPagetitle from '../../layouts/MainPagetitle';
import TripReviewService from '../../api/services/TripReviewService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import moment from 'moment';
import swal from "sweetalert";
import { downloadExcel } from 'react-export-table-to-excel';
const TravelPlannerList = () => {
const navigate = useNavigate();
    const [travel, settravel] = useState([]);
    const [numberOfdays, setnumberOfdays] = useState([]);
    const [isLoading, setisloading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPage = 50;
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;
    const records = travel.slice(firstIndex, lastIndex);
    const npage = Math.ceil(travel.length / recordsPage)
    const number = [...Array(npage + 1).keys()].slice(1)
    useEffect(() => {
        if (localStorage.getItem("admintoken")) {
            getTravel();
		}
		else {
			navigate('/')
		}
       
    }, []);
    function prePage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }

    function changeCPage(id) {
        setCurrentPage(id);
    }

    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }
    const getTravel = async () => {
        try {
            let trip = await TripReviewService.tripcheckout().json();
            settravel(trip.data);
            setnumberOfdays(trip.number_of_night)
            setisloading(false);
        } catch (error) {

        }
    };
    const handlePaidStatus = async (e) => {

        e.preventDefault();
        let id = e.target.id
        try {
            var userData = {
                "id": id,
            }
            let responseData = await TripReviewService.updatepaidstatus(userData).json();
            swal("Updated!!!").then((willUpdate) => {
                if (willUpdate) {
                    getTravel();
                }
            })


        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                // setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }

    }
    const updatechecktatus = async (e) => {
        e.preventDefault();
        let userid = e.target.id
        try {
            var userData = {
                id: userid
            }
            let responseData = await TripReviewService.updatecheckstatus(userData).json();
            let responseDataTrip = await TripReviewService.updateTripstatus(userid).json();
            if (responseData.status === true || responseDataTrip.status == true) {

                swal("Updated!!!").then((updatecheckstatus) => {
                    if (updatecheckstatus) {
                        getTravel();
                        window.location.reload();
                    }
                })
            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                // setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }

    }
    const header = [
        "Checked",
        "Name",
        "Email",
        "Phone Number",
        "Number of Days",
        "Start Date",
        "End Date",
        "Billing User Name",
        "Billing Email",
        "Billing Amount",
        "Pays Cash (COD)",
        "Payment Status",
        "Date of Birth",
        "Street",
        "Address Addition",
        "Zip",
        "City",
        "Country",
        "VAT ID",
        "Company",
    ];
    const tableData = travel.map((row, index) =>
        header.map((nw, i) =>
            [nw === "Checked" ? row.is_checked === 1 ? "Checked" : "Not Checked" : '',
            nw === "Name" ? row.first_last_name : '',
            nw === "Email" ? row.email : '',
            nw === "Phone Number" ? row.phone : '',
            nw === "Number of Days" ? numberOfdays[index] : '',
            nw === "Start Date" ? row.start_date ? moment(row.start_date).format('DD.MM.YYYY') : '' : '',
            nw === "End Date" ? row.end_date ? moment(row.end_date).format('DD.MM.YYYY') : '' : '',
            nw === "Billing User Name" ? row.billing_name : '',
            nw === "Billing Email" ? row.billing_email : '',
            nw === "Billing Amount" ? row.price : '',
            nw === "Pays Cash (COD)" ? row.is_cod === 1 ? "Yes" : "No" : '',
            nw === "Payment Status" ? row.is_paid === 1 ? "paid" : "Unpaid" : '',
            nw === "Date of Birth" ? row.dob ? moment(row.dob).format('DD.MM.YYYY') : '' : '',
            nw === "Street" ? row.street : '',
            nw === "Address Addition" ? row.address_addition : '',
            nw === "Zip" ? row.zip_code : '',
            nw === "City" ? row.city : '',
            nw === "Country" ? row.country : '',
            nw === "VAT ID" ? row.vat_id : '',
            nw === "Company" ? row.company_name : '']
        )
    )
    function useDownloadExcel() {
        downloadExcel({
            fileName: "Manage Booking",
            sheet: "Manage Booking",
            tablePayload: {
                header,
                body: tableData
            },
        });
    }
    const handleDelete = async (e) => {
        
        try {
            let responseData = await TripReviewService.tripdestroy(e).json()
            if (responseData.status === true) {
                swal("Trip Delete Succesfully").then((willDelete) => {
                    if (willDelete) {
                        getTravel(); 
                    }
                })

            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
               
            }
        }
    }
    return (
        <>
            <MainPagetitle mainTitle="Manage Travel Planner" pageTitle={'Manage Travel Planner'} parentTitle={'Home'} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0">Manage Travel Planner</h4>
                                        <button onClick={useDownloadExcel} className="btn btn-primary btn-sm ms-1"> Export Excel </button>
                                    </div>
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr>
                                                    <th>No.</th>
                                                    <th>
                                                        Checked
                                                    </th>
                                                    <th>First & Last Name</th>
                                                    <th>Email</th>
                                                    <th>Phone Number</th>
                                                    <th>Number of Days</th>
                                                    <th>Start Date (dd/mm/yyyy)</th>
                                                    <th>End Date (dd/mm/yyyy)</th>

                                                    <th>Billing User Name</th>
                                                    <th>Billing Email</th>
                                                    <th>Billing Amount</th>
                                                    <th>Pays Cash (COD)</th>
                                                    <th>Payment Status</th>
                                                    <th>Date of Birth</th>
                                                    <th>Street</th>
                                                    <th>Address Addition</th>
                                                    <th>Zip</th>
                                                    <th>City</th>
                                                    <th>Country</th>
                                                    <th>VAT ID</th>
                                                    <th>Company</th>
                                                    <th style={{ textAlign: 'left' }}><strong >Action</strong></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {records.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <div className="products">
                                                                <h6>{index + 1}</h6>
                                                            </div>
                                                        </td>
                                                        <td>{item.is_checked == 0 || item.ischecked == 1 ? <span className="btn btn-danger btn-sm ms-1">Not Checked</span> : 
                                                            <span className="btn btn-success btn-sm ms-1">Checked</span>}
                                                            <Link id={item.id}   onClick={updatechecktatus}> Change?  </Link>
                                                        </td>
                                                        <td>
                                                            <div className="products">
                                                                <h6>{item.first_last_name}</h6>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="products">
                                                                <h6>{item.email}</h6>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <h6>{item.phone}</h6>

                                                        </td>
                                                        <td>
                                                            <h6>{numberOfdays[index]}</h6>

                                                        </td>

                                                        <td>
                                                            <h6>{moment(item.start_date).format('DD/MM/YYYY')}</h6>

                                                        </td>

                                                        <td>
                                                            <h6>{moment(item.end_date).format('DD/MM/YYYY')}</h6>

                                                        </td>
                                                        <td>
                                                            <h6>{item.billing_name ? item.billing_name : '-'}</h6>
                                                        </td>
                                                        <td>
                                                            <h6>{item.billing_email ? item.billing_email : '-'}</h6>
                                                        </td>
                                                        <td>
                                                            <h6>{item.price}</h6>
                                                        </td>
                                                        <td>
                                                            <h6>{item.is_cod == 1 ? "yes" : "No"}</h6>
                                                        </td>
                                                        <td>
                                                            {/* <h6>{item.is_paid==1?"Paid":"Not Paid"}</h6> */}
                                                            <h6>{item.is_paid == 1 ? <span className="btn btn-success btn-sm ms-1">Paid</span> : <span className="btn btn-danger btn-sm ms-1">Unpaid</span>}</h6>
                                                            <Link id={item.id} onClick={handlePaidStatus}> Change?</Link>
                                                        </td>

                                                        <td>
                                                            <h6>{moment(item.dob).format('DD/MM/YYYY')}</h6>
                                                        </td>
                                                        <td>
                                                            <h6>{item.street}</h6>
                                                        </td>
                                                        <td>
                                                            <h6>{item.address_addition}</h6>
                                                        </td>
                                                        <td>
                                                            <h6>{item.zip_code}</h6>
                                                        </td>
                                                        <td>
                                                            <h6>{item.city}</h6>
                                                        </td>
                                                        <td>
                                                            <h6>{item.country}</h6>
                                                        </td>
                                                        <td>
                                                            <h6>{item.vat_id}</h6>
                                                        </td>
                                                        <td>
                                                            <h6>{item.company_name}</h6>
                                                        </td>
                                                        <td>
                                                            <Link
                                                                onClick={() =>
                                                                    swal({
                                                                        title: "Are you sure?",
                                                                        text: "Once deleted, you will not be able to recover this data!",
                                                                        icon: "warning",
                                                                        buttons: true,
                                                                        dangerMode: true,
                                                                    }).then((willDelete) => {
                                                                        if (willDelete) {
                                                                            (handleDelete(item.id));
                                                                        }
                                                                    })
                                                                }

                                                                className="btn btn-danger"
                                                            >
                                                                Delete
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        <div className="d-sm-flex text-center justify-content-between align-items-center">
                                            <div className='dataTables_info'>
                                                Showing {lastIndex - recordsPage + 1} to{" "}
                                                {travel.length < lastIndex ? travel.length : lastIndex}
                                                {" "}of {travel.length} entries
                                            </div>
                                            <div
                                                className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                id="example2_paginate"
                                            >
                                                <Link
                                                    className="paginate_button previous disabled"
                                                    to="#"
                                                    onClick={prePage}
                                                >
                                                    <i className="fa-solid fa-angle-left" />
                                                </Link>
                                                <span>
                                                    {number.map((n, i) => (
                                                        <Link className={`paginate_button ${currentPage === n ? 'current' : ''} `} key={i}
                                                            onClick={() => changeCPage(n)}
                                                        >
                                                            {n}

                                                        </Link>
                                                    ))}
                                                </span>
                                                <Link
                                                    className="paginate_button next"
                                                    to="#"
                                                    onClick={nextPage}
                                                >
                                                    <i className="fa-solid fa-angle-right" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <LogoAnimationLoader />}
        </>
    );
};

export default TravelPlannerList;